<template>
  <div
    class="index__menu"
    ref="indexMenu"
    :class="{
      'isHiddenByScroll': isMainMenuHidden,
      'isWithBackground': isMainMenuBackgroundFilled,
    }"
  >
    <nav class="index__menu__list">
      <router-link
        :to="{ name: 'projects', params: { activeSection: 'all' } }"
        :event="''"
        @click.native.prevent="onFollowLink({ name: 'projects', params: { activeSection: 'all' } })"
        class="index__menu__link hover-link a-link"
      >{{ $t('menu_projects') }}</router-link>
      <router-link
        :to="{ name: 'company' }"
        :event="''"
        @click.native.prevent="onFollowLink({ name: 'company' })"
        class="index__menu__link hover-link a-link"
      >{{ $t('menu_company') }}</router-link>
      <router-link
        :to="{ name: 'contacts' }"
        :event="''"
        @click.native.prevent="onFollowLink({ name: 'contacts' })"
        class="index__menu__link hover-link a-link"
      >{{ $t('menu_contacts') }}</router-link>
    </nav>
    <!-- <a
      href="#"
      class="index__menu__lang"
      @click="onChangeLanguage"
    >{{ differentLanguage }}</a> -->
  </div>
</template>

<script lang="ts">
import { globalMixin, scrollMixin } from '../mixins'

export default {
	mixins: [globalMixin, scrollMixin],
};
</script>

